import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import THEME from '../../theme';
import DefaultSummary from './DefaultSummary';
import { selectTemplatesMap } from '@debbie/cortex/dist/templates/selectors';
import Badge from '../Badge';
const SMSTags = styled.span `
  & > div {
    background: ${THEME.SUCCESS};
    display: inline-block;
    border-radius: 3px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 0.2em 0.6em;
    font-size: 0.7em;
    font-weight: bold;
    margin-right: 5px;

    &.failed {
      background: ${THEME.DANGEROUS};
    }
  }
`;
const SMSSummary = (props) => {
    var _a;
    const interaction = props.interaction;
    const lang = useSelector((s) => s.lang);
    const sms = props.interaction.details;
    const events = props.interaction.events
        .filter((event, index) => props.interaction.events.findIndex((e) => e.type === event.type) ===
        index)
        .filter((event) => !['accepted'].includes(event.type));
    const textParts = sms.text && sms.text.split('\n');
    const template = useSelector((s) => {
        const templatesMap = selectTemplatesMap(s);
        return ((interaction.templateId && templatesMap[interaction.templateId]) || null);
    });
    return (React.createElement(DefaultSummary, Object.assign({}, props),
        template && (React.createElement(React.Fragment, null, !!((_a = template.tags) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement("p", { style: { marginTop: 0 } }, template.tags.map(({ tag }) => (React.createElement(Badge, { style: { marginRight: 5 }, theme: THEME.COLOR_ACCENT }, lang.templateTags[tag]))))))),
        React.createElement("div", null,
            sms.from,
            React.createElement("br", null),
            React.createElement("span", { style: { fontSize: '.8em' } }, sms.countryCode),
            " ",
            sms.number),
        React.createElement(SMSTags, null, !!(events && events.length) &&
            events.map((e) => (React.createElement("div", { key: e.id, "data-tooltip-content": events
                    .filter((s) => s.type === e.type)
                    .map((s) => `${moment(s.createdAt).format(THEME.DATE_FORMAT_LONG)}`)
                    .join('<br/>'), "data-tooltip-id": `tooltip-default`, className: e.type },
                // @ts-ignore
                lang.interactions[e.type] || e.type,
                ' ')))),
        React.createElement("p", null, textParts &&
            textParts.map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                item,
                index !== textParts.length - 1 && React.createElement("br", null)))))));
};
export default SMSSummary;
//# sourceMappingURL=SMSSummary.js.map